import { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { DropClassProp } from "../../../../types/Applications";
import SvgIcon from "../../../../coreComponents/SvgIcon";

// This component renders a dropdown menu for a contact in the chat interface. It includes options to view details, send messages, and add to favorites.
export const ContactEdit:React.FC<DropClassProp> = ({ dropClass }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div className={`contact-edit ${dropClass}`}>
      <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
        <DropdownToggle color="transparent">
          <SvgIcon iconId="menubar"/>
        </DropdownToggle>
        <DropdownMenu end>
          <DropdownItem>View details</DropdownItem>
          <DropdownItem>Send messages</DropdownItem>
          <DropdownItem>Add to favorites</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
